import { c as _c } from "react/compiler-runtime";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Stack } from "@mui-wrapper";
import { FilterIcon, FilterWithBadgeIcon, Text } from "@flat-ui";
import { useMemo } from "react";
/** The filter title and icon shown at the beginning of filter toolbar */
export function FilterToolbarTitle(t0) {
  const $ = _c(18);
  const {
    shouldShowFilterChips: t1,
    setShouldShowFilterChips
  } = t0;
  const shouldShowFilterChips = t1 === undefined ? true : t1;
  const {
    isScreenMdOrSmaller
  } = useMediaQueryList();
  const {
    isAnyFilterApplied
  } = useFilterQueryParams();
  const areFilterChipsVisibleInSmallScreen = isScreenMdOrSmaller && shouldShowFilterChips;
  let t2;
  bb0: {
    if (isScreenMdOrSmaller && isAnyFilterApplied && !shouldShowFilterChips) {
      let t3;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <FilterWithBadgeIcon sx={{
          width: "18px",
          height: "18px"
        }} />;
        $[0] = t3;
      } else {
        t3 = $[0];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FilterIcon sx={{
        width: "18px",
        height: "18px"
      }} />;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    t2 = t3;
  }
  const filterIcon = t2;
  let t3;
  if ($[2] !== setShouldShowFilterChips || $[3] !== shouldShowFilterChips) {
    t3 = () => setShouldShowFilterChips?.(!shouldShowFilterChips);
    $[2] = setShouldShowFilterChips;
    $[3] = shouldShowFilterChips;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isScreenMdOrSmaller ? "pointer" : "default";
  const t5 = isScreenMdOrSmaller ? "action.hover" : "";
  const t6 = isScreenMdOrSmaller ? "primary.main" : "";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = {
      backgroundColor: t5,
      color: t6
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = areFilterChipsVisibleInSmallScreen ? "action.selected" : "";
  const t9 = areFilterChipsVisibleInSmallScreen ? "primary.main" : "text.primary";
  let t10;
  if ($[8] !== t4 || $[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
    t10 = {
      cursor: t4,
      px: "10px",
      py: "6px",
      "&:hover": t7,
      backgroundColor: t8,
      color: t9,
      alignItems: "center"
    };
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text variant="heading12" sx={{
      color: "inherit",
      ml: "8px"
    }}>Filters</Text>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== filterIcon || $[15] !== t10 || $[16] !== t3) {
    t12 = <Stack direction="row" onClick={t3} sx={t10}>{filterIcon}{t11}</Stack>;
    $[14] = filterIcon;
    $[15] = t10;
    $[16] = t3;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}